'use client';

import { CampaignIDs } from '@energy-retailer/constants';
import { deleteCookie, getCookie } from 'cookies-next';
import { useEffect, useState } from 'react';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Modal, ModalButton, BaseModalContent } from '@/components/modal';
import { ANALYTICS_EVENTS, PROMO_TITLE_COOKIE, PROMO_ID_COOKIE, PROMO_TERMS_URL_COOKIE } from '@/constants';

import { Button } from '../button';

type OneBigSwitchModalProps = {
  setPromotionId: (id?: string | undefined) => void;
};

export const OneBigSwitchModal = ({
  setPromotionId,
}: OneBigSwitchModalProps) => {
  const promoId = getCookie(PROMO_ID_COOKIE);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isModalOpen) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.oneBigSwitchModal.openModal, {});
    }
  }, [isModalOpen]);

  if (promoId !== CampaignIDs.OneBigSwitch) {
    return null;
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  function openModal() {
    setIsModalOpen(true);
  }

  const clearPromo = () => {
    deleteCookie(PROMO_TITLE_COOKIE);
    deleteCookie(PROMO_TERMS_URL_COOKIE);
    deleteCookie(PROMO_ID_COOKIE);
    setPromotionId(undefined);
  };

  return (
    <>
      <div className="flex items-center justify-center">
        <Button
          onClick={openModal}
          variant="secondary"
        >
          See All Plans
        </Button>
      </div>

      <Modal
        expandHeader
        heading="Before we continue"
        description="If you choose to see all available plans through Powershop, you will lose One Big Switch offered $50 credit voucher. Would you still like to view all plans?"
        isModalOpen={isModalOpen}
        openModal={openModal}
      >
        <BaseModalContent
          buttonComponent={
            <>
              <ModalButton
                variant="primary"
                onClick={() => {
                  trackAnalyticsEvent(
                    ANALYTICS_EVENTS.oneBigSwitchModal.viewAllPlans,
                    {}
                  );
                  clearPromo();
                  closeModal();
                }}
              >
                Yes, view all plans.
              </ModalButton>

              <ModalButton
                variant="tertiary"
                onClick={() => {
                  trackAnalyticsEvent(
                    ANALYTICS_EVENTS.oneBigSwitchModal.keepCurrentOffer,
                    {}
                  );
                  closeModal();
                }}
              >
                No, keep current offer.
              </ModalButton>
            </>
          }
        />
      </Modal>
    </>
  );
};
